package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.style.*
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.px

val SiteButtonStyle by ComponentStyle {
    base {
        Modifier.color(color = Colors.White)
            .height(60.px)
            .borderRadius(50.px)
    }
}

val SiteButtonDialogVariant by SiteButtonStyle.addVariant {
    val toSitePalette = colorMode.toSitePalette()
    base {
        Modifier.height(40.px)
            .color(toSitePalette.brand.primary)
            .backgroundColor(Colors.Transparent)
    }
    hover {
        Modifier
            .background(toSitePalette.brand.primary.toRgb().copy(alpha = 10))
    }
}

@Composable
fun SiteButton(
    modifier: Modifier = Modifier,
    onClick: () -> Unit,
    loading: Boolean = false,
    variant: ComponentVariant? = null,
    buttonType: ButtonType = ButtonType.Button,
    enabled: Boolean = true,
    content: @Composable () -> Unit,
) {
    Button(
        onClick = {
            it.preventDefault()
            if (!loading) {
                onClick()
            }
        }, modifier = Modifier.then(modifier)
            .then(SiteButtonStyle.toModifier(variant)),
        type = buttonType,
        enabled = enabled
    ) {
        if (loading) {
            LoadingView()
        } else
            content()
    }
}